<!--
 * @Author: xiec@linkstec.com
 * @Date: 2021-02-27 16:21:17
 * @Function: Please Input Function
-->

<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <div class="" style="height:400px">
      <a-tree
        :tree-data="gData"
        @select="onSelect"
        :selectedKeys="selectedKeys"
        :replaceFields="replaceFields"
      >
        <!-- <template slot="title" slot-scope="text">
          <div class="title-con" style="">
            <div class="title-name">
              {{ text }}
            </div>
          </div>
        </template> -->
      </a-tree>
    </div>
  </a-modal>
</template>

<script>

  import {removeBatch,queryExerciseTreeList} from "@api/api"
  export default {
    name: 'ExerciseSelectTypeModal',
    components: {
    },
    data () {
      return {
        title: '修改分类',
        width: 800,
        visible: false,
        disableSubmit: false,
        selectedKeys: [],
        selectedRowKeys:[],
        replaceFields : {
          title:'name'
        },
        gData: [
        //   {
        //     id: 1,
        //     key: 1,
        //     isEdit: false, // 是否处于编辑状态
        //     isNewItem: false, // 该节点是否是新增节点
        //     title: '节点名字',
        //     depth: 1, // 该节点的层级
        //     scopedSlots: { title: 'title' }, // 自定义组件需要绑定
        //     children: [
        //       {
        //         id: 2,
        //         key: 2,
        //         isEdit: false, // 是否处于编辑状态
        //         isNewItem: false, // 该节点是否是新增节点
        //         title: '子节点名字',
        //         depth: 2, // 该节点的层级
        //         scopedSlots: { title: 'title' }
        //       },
        //       {
        //         id: 21,
        //         key: 21,
        //         isEdit: false, // 是否处于编辑状态
        //         isNewItem: false, // 该节点是否是新增节点
        //         title: '子节点名字',
        //         depth: 2, // 该节点的层级
        //         scopedSlots: { title: 'title' }
        //       }
        //     ]
        //   }
        ]
      }
    },
    methods: {
      open (selectedRowKeys, data) {
        this.selectedRowKeys = selectedRowKeys;
         this.loadTree();
        this.visible = true;
      },
      edit (record) {
        this.visible = true
      },
      onSelect(selectedKeys, info) {
        this.selectedKeys = selectedKeys;
      },
      close () {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        let ids = "";
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ",";
        }
        if(this.selectedKeys.length == 0){
          this.$message.warning('请选择目标分类');
          return;
        }
        let param = {
          'catalogId':this.selectedKeys[0],
          'ids':ids
        }
        removeBatch(param).then(res=>{
          if(res.success){
            // TODO 刷新页面
          }
        })
        this.$emit('ok')
        this.visible = false
      },
      loadTree(){
        queryExerciseTreeList().then((res) => {
           if (res.success) {
             this.gData=res.result;
             this.gData.forEach(item=>{
               item.selectable = false;
             })
           }else {
            this.$message.warning(res.message)
          }
        console.log(res);
        }).finally(() => {
        })
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
